import { defineComponent as _defineComponent } from 'vue';
import { onMounted, ref, getCurrentInstance, watch } from 'vue';
import lineEcharts from '@blade-sxp/file-cluster/components/line-echarts.vue';
import fileEchartConfig from './config/fileEchartConfig';
import snapshotsEchartConfig from './config/snapshotsEchartConfig';
import moment from 'moment';
export default /*#__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        type: null,
        lineChartData: null
    },
    setup(__props) {
        const props = __props;
        const curInstance = getCurrentInstance().proxy;
        const option = props.type === 'files' ? fileEchartConfig(curInstance) : snapshotsEchartConfig(curInstance);
        const lineEchartsRef = ref(null);
        const dataSeries = ref([]);
        const xAxis = ref([]);
        onMounted(() => {
        });
        watch(() => props.lineChartData, (value) => {
            addDataToOption(option, value);
            // 取出第0项 作为x轴坐标
            addDataToxAxis(value?.[0]?.values);
        });
        function handleResize() {
            lineEchartsRef.value && lineEchartsRef.value.onResize();
        }
        function addDataToOption(config, data) {
            const commonLineStyle = config.series[0];
            const customSeries = [];
            data.forEach((item, index) => {
                customSeries[index] = { ...commonLineStyle };
                customSeries[index].name = item.name;
                customSeries[index].data = [];
                item.values.forEach((value) => {
                    customSeries[index].data.push(value.value);
                });
            });
            dataSeries.value = customSeries;
        }
        function addDataToxAxis(values) {
            if (!values)
                return;
            values.forEach(item => {
                const formatData = formatDate(item.time);
                xAxis.value.push(formatData);
            });
        }
        // 格式化时间
        function formatDate(timeStamp) {
            const time = Number(timeStamp);
            return moment(new Date(time)).format('MM-DD');
        }
        return { __sfc: true, props, curInstance, option, lineEchartsRef, dataSeries, xAxis, handleResize, addDataToOption, addDataToxAxis, formatDate, lineEcharts };
    }
});
